import { LocalStorageKeys } from "@is/constants";
import { LocalStorageService } from "@is/services";
import { getEnvValue } from "@is/utils/env";

const ENVIRONMENT = getEnvValue("VITE_ENVIRONMENT")?.toUpperCase();
const SLACK_URL = getEnvValue("VITE_SLACK_HOOKS_URL");
const LOCALHOST = "localhost";

export function sendErrorMessageToSlack(message: string) {
  if (window.location.hostname === LOCALHOST) {
    return;
  }

  const exceptionsEnv = `'exceptions-${ENVIRONMENT.toLowerCase()}'`;

  const tenantId = LocalStorageService.getItem(LocalStorageKeys.TenantId);
  const storeId = LocalStorageService.getItem(LocalStorageKeys.StoreId);
  const deviceId = LocalStorageService.getItem(LocalStorageKeys.DeviceId);
  const languageCode = LocalStorageService.getItem(
    LocalStorageKeys.LanguageCode
  );
  const countryCode = LocalStorageService.getItem(LocalStorageKeys.CountryCode);
  const sessionId = LocalStorageService.getItem(LocalStorageKeys.SessionId);
  const scannerDetails = LocalStorageService.getItem(
    LocalStorageKeys.ScannerDetails
  );
  const version = LocalStorageService.getItem(LocalStorageKeys.Version);
  const lastUpdatedAt = LocalStorageService.getItem(
    LocalStorageKeys.LastUpdateAt
  );
  const url = window.location.href;
  const isOnline = window.navigator.onLine;

  const text =
    ENVIRONMENT +
    " alert " +
    exceptionsEnv +
    " \n\n" +
    "Error: " +
    message +
    " \n\n" +
    "Details: \n\n" +
    "online - " +
    isOnline +
    " \n" +
    "tenant ID - " +
    tenantId +
    " \n" +
    "store ID - " +
    storeId +
    " \n" +
    "device ID - " +
    deviceId +
    " \n" +
    "languageCode - " +
    languageCode +
    " \n" +
    "countryCode - " +
    countryCode +
    " \n" +
    "sessionId - " +
    sessionId +
    " \n" +
    "scannerDetails - " +
    scannerDetails +
    " \n" +
    "version - " +
    version +
    " \n" +
    "lastUpdatedAt - " +
    lastUpdatedAt +
    " \n" +
    "url - " +
    url +
    " \n";

  fetch(SLACK_URL, {
    method: "POST",
    body: new URLSearchParams({
      payload: JSON.stringify({ text }),
    }),
  });
}
